var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerfusion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7435 16.0947H16.4102V14.7614H17.7435V12.0947L24.4102 15.4281L17.7435 18.7614V16.0947ZM12.4102 16.0947V14.7614H15.0768V16.0947H12.4102ZM8.41016 16.0947V14.7614H11.0768V16.0947H8.41016ZM4.41016 16.0947V14.7614H7.07682V16.0947H4.41016ZM0.410156 16.0947V14.7614H3.07682V16.0947H0.410156ZM0.410156 3.42806L7.07682 0.0947266V2.76139H24.4102V4.09473H7.07682V6.76139L0.410156 3.42806Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfusion);
export default __webpack_public_path__ + "static/media/perfusion.a1fe195016fdb4e0bf9bbce85bb86ad9.svg";
export { ForwardRef as ReactComponent };